<template>
  <div
    class="effect-setting setting-popup"
    v-if='boxData.judgeBox'
    :style="{'top': boxData.fix.y+'px', 'left': boxData.fix.x+'px', 'z-index': boxData.Zindex}"
    @mousedown.stop.prevent
  >
    <div
      class="setting-popup__drag-area"
      @mousedown="moveStart($event, true)"
      @mousemove="moveArea($event)"
      @mouseup="saveMoveState($event)" :style="{'cursor': 'move'}"
    >
      手绘时间设置
    </div>

    <div class="settting-popup__content">
      <ul class="items">
        <li class="item">
          <div class="item__title">手绘时间</div>
          <div class="item__main">
            {{sec}}s
          </div>
        </li>
        <li class="item" style="justify-content: center;">
          <div class="num">0.5s</div>
          <div class="item__main" style="padding-left: 18px;padding-right: 18px;">
            <slider
              :runway-size="130"
              :number-unit="'%'"
              :showCounter="false"
              :step="0.5"
              :numFixed="1"
              :minVal="0.5"
              :maxVal="pureStaySec"
              @updateValue="onDdSliderUpdated"
              ref="ddSlider"
            ></slider>
          </div>
          <el-tooltip v-model="isShowTip" class="item" effect="dark" placement="right" :manual='true'>
            <div slot="content" v-html="tip"></div>
            <div class="num">{{pureStaySec}}s</div>
          </el-tooltip>
        </li>
      </ul>
    </div>

    <div class="setting-popup__close" @click="close"><i class="icon-popup-close"></i></div>
    <div class="setting-popup__mask" v-show="isShowMask" @click="closeNextPopup('color')"></div>
  </div>
</template>

<script>
import popup from '../mixins/popup.vue'
import slider from '../popups/content/slider.vue'

export default {
  mixins: [popup],
  components: {
    slider
  },
  data () {
    return {
      popupType: 'drawingDuration',
      sec: 0,
      pureStaySec: 0,
      ready: false,
      tip: '调整您的出入场时间跨度, <br/>可再次调节动画速度',
      isShowTip: false,
      tipTid: null
    }
  },
  watch: {
    'boxData.judgeBox': {
      handler (val) {
        if (val) {
          this.render();
        }
      }
    },
    'boxData.fix': {
      handler () {
        this.isShowTip = false;
      },
      deep: true
    },
    'sprite.effect.drawingDuration': {
      handler (val) {
        this.render();
      }
    }
  },
  methods: {
    render () {
      const vm = this;

      let sec = (this.sprite.effect.drawingDuration / 1000 || 0).toFixed(1) - 0;
      let pureStaySec = (this.sprite.effect.exitAnim.start - this.sprite.effect.entranceAnim.end) / 1000;
      this.pureStaySec = Math.max(pureStaySec, 0.5);

      this.$nextTick(() => {
        vm.$refs.ddSlider
          && vm.$refs.ddSlider.updateValFromOutside(sec);
      })
    },
    onDdSliderUpdated (val, undo) {
      const vm = this;
      let ddSlider = vm.$refs.ddSlider;
      this.sec = val;
      if (undo && ddSlider && ddSlider.item.min < ddSlider.item.max) {
        this.sprite.updateEffect({
          drawingDuration: val * 1000
        }, true).then(() => {
          this.$bus.emit('updateEffect_vue', {type: 'drawingDuration'});
        });
      }

      if (val === ddSlider.item.max) {
        this.isShowTip = true;
        clearTimeout(this.tipTid);
        this.tipTid = setTimeout(() => {
          this.isShowTip = false;
        }, 4000);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.setting-popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 258px;
  min-height: 180px;
  z-index: 35;
  border-radius: 8px;
  background: #fff;
  overflow: hidden;
  font-size: 14px;
  box-shadow: 0 0 3px 1px #d8dee9;
  color: #474261;

  &__drag-area {
    line-height: 28px;
    background: #d8dee9;
    text-align: left;
    text-indent: 14px;
    cursor: move;
  }

  &__close {
    position: absolute;
    top: 7px;
    right: 12px;
    height: 14px;
    line-height: 14px;
    width: 14px;
    cursor: pointer;
  }

  &__content {
    padding: 14px 0;
  }

  &__mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(#ffffff, 0.7);
  }
}

.items {
  padding-top: 25px;
}

.items > .item {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-left: 14px;
  padding-right: 14px;
  margin-bottom: 25px;

  &__title {
    flex-shrink: 0;
    width: 56px;
    margin-right: 10px;
    text-align: left;
  }
}

.color {
  width: 75px;
  height: 30px;
  border-radius: 4px;
  background-color: #5779fa;
  cursor: pointer;
  box-shadow: 0 0 3px 0px rgba(0,0,0,0.5);
}

.dropdown {
  position: relative;
  &__select {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 80px;
    height: 30px;
    line-height: 30px;
    border: solid 1px #f0f0f8;
    margin-left: 15px;
    cursor: pointer;
    text-align: left;
    padding-left: 12px;
    padding-right: 12px;
  }
  &__options {
    // position: absolute;
    z-index: 1;
    top: 120%;
    left: 15px;
    width: 80px;
    border: solid 1px #f0f0f8;
  }
  &__item {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 24px;
    line-height: 24px;
    background-color: #fff;
    cursor: pointer;

    & > span:nth-child(1) {
      width: 25px;
      text-align: left;
      color: #9692a9;
    }
    &:hover, &.active {
      background-color: #f0f0f8;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/popupsNew/drawingDuration.vue